export function isChildOf(element: HTMLElement, selector: string) {
  return !!element.closest(selector);
}